function SSVolumeControl(config){
  this.config = config;
  this._init();
}

SSVolumeControl.prototype._init = function(){
  var renderTo = this.config.renderTo;
  var container = this.container = this.config.container;
  this.wrapper = container.find('.jspl_volume_interface_wrapper');
  var inputTag = container.find('.jspl_volume_interface>input');
  // detect if rangeinput is available
  var rangeInputCheck = document.createElement('input');
  rangeInputCheck.setAttribute('type', 'range');
  if (rangeInputCheck.type !== 'range'){
    this.mode = 'htmlfallback';
    this.range = inputTag.rangeinput({
      keyboard : false,
      value:50,
      vertical:true,
      css : {
        input : 'jspl_vol_range',
        slider : 'jspl_vol_slider',
        progress : 'jspl_vol_progress',
        handle : 'jspl_vol_handle'
      }
    });
    this.scriptInterface = this.range.data('rangeinput');
  } else {
    this.mode = 'html5';
    this.range = inputTag;
    this.scriptInterface = this.range.get(0);
  }
  container.insertAfter(renderTo);
  this._bindEvents();
};

SSVolumeControl.prototype._bindEvents = function(){
  var that = this;
  // @note if the user clicks on the volume icon, we show. Event is bound in toolbar class
  
  // if user clicks on the range input we trigger volume change events
  this.range.bind('change', 
    (this.mode === 'html5') ?
    function(event){
      $.slideshareEventManager.trigger('changevolume', {
        volume : event.currentTarget.value
      });
    } :
    function(event, value){
      $.slideshareEventManager.trigger('changevolume', {
        volume : value
      });
    }
  );
  // if the user clicks outside the rangeinput anywhere, we hide the control
  this.wrapper.bind('click mouseleave', function(){
    $.slideshareEventManager.trigger('hidevolumecontrol');
  });
  
  ((this.mode === 'html5') ? 
    this.range : 
    this.wrapper.find('.jspl_volume_interface')
  ).bind('click', function(e){
    e.stopPropagation();
  });
};

SSVolumeControl.prototype.show = function(){
  var leftOffset = $('.btnVolume').offset().left - this.config.player.offset().left - 10;
  this.wrapper.css('left', (leftOffset || 0));
  this.container.show();
  this.config.trigger.addClass('pressed');
};

SSVolumeControl.prototype.hide = function(){
  this.container.hide();
  this.config.trigger.removeClass('pressed');
};

SSVolumeControl.prototype.setVolume = function(volume){
  this.mode === 'html5' ? (this.scriptInterface.value = volume) : this.scriptInterface.setValue(volume);
};
